//About Us Modal Component
import React from 'react';
import { connect } from 'react-redux';
import '../../stylesheets/custom.css';

class AboutUs extends React.Component {
    constructor(props, context) {
        super(props, context);

    }
    render() {
        return <div>
            <div className="about-us">
                <h1>About us</h1>
                <p>The Neighbourhood Dashboard aggregates civic-environmental data along with governance data at a neighbourhood level for cities around India. We are displaying it on a map and presenting it to you as a set of charts.</p>
                <p>Our objective is to become the platform for</p>
                <p>- understanding what is happening in your neighourhood</p>
                <p>- holding the local governance accountable.</p>
                <p>Please Note - this data is being shown AS IS. We are not responsible for errors which might come in. However, please do inform us of errors, and if possible, we will make amends on our data.</p>

                <h4>Some Users and Use Cases</h4>
                <ul>
                    <li><strong>1. Solve Ninja/Youth/Citizens - </strong>
                        <ul>
                            <li>Discover the existing Governance Infrastructure in your neighbourhood</li>
                            <li>see visualised issues and Government Redressal mechanisms in your neighbourhood</li>
                        </ul>
                    </li>
                    <li><strong>2. RWA/Corporator/MLA - </strong>
                        <ul>
                            <li>Do what the Solve Ninja/Youth/Citizen can do and</li>
                            <li>Use this as a tool to make teams/agencies accountable</li>
                        </ul>
                    </li>
                    <li><strong>3. Media and Academics - </strong>
                        <ul>
                            <li>Do all of the above and be able to infer how the quickly the neighbourhood responds to issues and how capable it is to resolve them quickly.</li>
                        </ul>
                    </li>
                </ul>
                <h4>We have data on the following levels</h4>
                <ul>
                    <li><strong>Governance</strong>
                        <ol>
                            <li>Ward / Corporator</li>
                            <li>Constituency / MLA</li>
                        </ol>
                    </li>
                    <li><strong>Government Redressal</strong>
                        <ol>
                            <li>Police Stations</li>
                            <li>Bus Stops</li>
                            <li>Parks and Playgrounds</li>
                            <li>Other Government Offices</li>
                        </ol>
                    </li>
                    <li><strong>Issues</strong>
                        <ol>
                            <li>Waste - Garbage dump sites / DWCC Locations / Waste Convertor Locations / Composting Locations</li>
                            <li>Water - Groundwater Quality / Lake Water Quality</li>
                            <li>Pothole - Pothole Locations</li>
                            <li>Air - Air Quality</li>
                            <li>Sanitation - Toilet locations</li>
                            <li>Education - School infrastructure data</li>
                            <li>Civic - BBMP Offices</li>
                            <li>Governance - Street Quality</li>
                        </ol>
                    </li>
                </ul>
                <h4>Data Providers</h4>
                <h4>We thank the following data providers for supplying the information used here:</h4>
                <ul>
                    <li>Opencity.in</li>
                    <li>FFEM</li>
                    <li>Testing Waters</li>
                    <li>Janaagraha</li>
                    <li>National University for Educational Planning and Administration</li>
                    <li>Data.gov.in</li>
                    <li>Central Pollution Control Board</li>
                    <li>Those Icons and FreePik on Flaticon.com</li>
                </ul>
                <h4>We thank for their support</h4>
                <ul>
                    <li>Suresh Nair</li>
                    <li>Sooraj Subramanian</li>
                    <li>Anirudha Mysore</li>
                    <li>Team Azureiken</li>
                </ul>
            </div >
        </div >;
    }
}
export default AboutUs;



// WEBPACK FOOTER //
// ./src/components/category/aboutUs.js